import { render } from "./tubeImage.vue?vue&type=template&id=1e16044c"
import script from "./tubeImage.vue?vue&type=script&lang=js"
export * from "./tubeImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__